import { defineComponent as y, computed as d, createElementBlock as o, openBlock as n, normalizeStyle as u, normalizeClass as c, createElementVNode as x, createCommentVNode as m, createVNode as h, renderSlot as p, toDisplayString as v } from "vue";
import { _ as w } from "./Icon.ce.vue_vue_type_script_setup_true_lang-CdOC0ycX.js";
import C from "./ImageSkeleton.ce.js";
const z = { class: "arbo-thumbnail__main" }, N = /* @__PURE__ */ y({
  __name: "Thumbnail.ce",
  props: {
    size: { default: "medium", type: String },
    thumbnail: { type: String },
    icon: { default: void 0, type: Object },
    footerLabel: { default: void 0, type: Object },
    disabled: { type: Boolean, default: !1 },
    url: { default: "", type: String },
    newTab: { type: Boolean },
    disableHover: { type: Boolean, default: !1 },
    active: { type: Boolean },
    enableMetaKeyOpen: { type: Boolean }
  },
  emits: ["onNormalClick", "onCommandClick"],
  setup(a, { emit: f }) {
    const t = a, b = f, g = d(() => {
      const i = t.size;
      let e = {
        boxSizing: "content-box",
        color: "white"
      };
      switch (i) {
        case "small":
          e.padding = "6px", e.height = "12px", e.width = "12px";
          break;
        case "medium":
          e.padding = "6px", e.height = "20px", e.width = "20px";
          break;
        case "large":
          e.padding = "10px", e.height = "28px", e.width = "28px";
          break;
      }
      return e;
    }), k = d(() => {
      const i = t.size;
      let e = {};
      switch (i) {
        case "small":
          e["min-height"] = "24px", e["max-height"] = "36px";
          break;
        case "medium":
          e["min-height"] = "37px", e["max-height"] = "120px";
          break;
        case "large":
          e["min-height"] = "121px", e["max-height"] = "unset";
          break;
      }
      return e["--hover-background"] = t.footerLabel?.backgroundColor || "rgba(0, 0, 0, 0.5)", e;
    }), r = (i, e, l) => {
      t.enableMetaKeyOpen ? i.metaKey || i.ctrlKey ? b("onCommandClick", e, i) : b("onNormalClick", e, i) : e && window.open(e, l ? "_blank" : "_self");
    }, s = (i, e) => {
      if (!t.disabled)
        switch (i.stopPropagation(), e) {
          case "self":
            r(i, t.url, t.newTab ?? !0);
            break;
          case "icon":
            t.icon && r(i, t.icon.url, t.icon?.newTab ?? !0);
            break;
          case "footer":
            t.footerLabel && r(i, t.footerLabel.url, t?.footerLabel?.newTab ?? !0);
            break;
        }
    };
    return (i, e) => (n(), o("div", {
      ref: "thumbnailRef",
      class: c(["arbo-thumbnail", {
        "border-radius-2": a.size === "small",
        "border-radius-4": a.size !== "small",
        active: a.active
      }]),
      style: u(k.value),
      onClick: e[2] || (e[2] = (l) => s(l, "self"))
    }, [
      x("div", z, [
        h(C, {
          src: a.thumbnail,
          alt: "thumbnail",
          height: "100%",
          width: "100%",
          showBrokenImage: !1
        }, null, 8, ["src"])
      ]),
      !a.disableHover && !a.disabled ? (n(), o("div", {
        key: 0,
        class: c(["arbo-thumbnail__hover", { active: a.active }])
      }, [
        p(i.$slots, "icon", {}, () => [
          t.icon && t.icon.iconName && t.icon.iconName.length > 0 ? (n(), o("div", {
            key: 0,
            class: c(["arbo-thumbnail__icon", { fill: t.size == "small" || a.footerLabel && !a.footerLabel.label }])
          }, [
            h(w, {
              name: a.icon ? a.icon.iconName : "",
              style: u(g.value),
              class: "icon",
              isSquareSize: !0,
              onClick: e[0] || (e[0] = (l) => s(l, "icon"))
            }, null, 8, ["name", "style"])
          ], 2)) : m("", !0)
        ]),
        a.size != "small" && a.footerLabel && a.footerLabel?.label.length > 0 ? (n(), o("div", {
          key: 0,
          class: "arbo-thumbnail__open",
          onClick: e[1] || (e[1] = (l) => s(l, "footer"))
        }, v(a.footerLabel.label), 1)) : m("", !0)
      ], 2)) : m("", !0)
    ], 6));
  }
});
export {
  N as _
};
